// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_averageTimeName__AXQKz {
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-transform: uppercase;
  margin-bottom: 7px;
  margin-top: 28px;
}

.styles_averageTimeContainer__bEmoc {
  display: flex;
  box-shadow: 0px 2px 15px 0px #64646426;
  background-color: #fff;
  border-radius: 6px;
  height: 77px;
  margin-bottom: 39px;
}

.styles_averageTimeBox__rnqol {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-right: 1px solid #cdcdcd;
}

.styles_averageTimeBox__rnqol:last-child {
  border-right: none;
}

.styles_averageTimeTitle__ZOaCE {
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0px;
}

.styles_averageTimeValue__4Ohuf {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-transform: uppercase;
  color: #4b4b4b;
}

.styles_view__\\+4Ep6 {
  position: relative;
  padding-bottom: 80px;
}

.styles_loader__uCGJ0 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.styles_history__oR8WX {
  background-color: #fff;
  border-radius: 4px;
  border: 0.5px solid var(--gray);
  padding: 6px 15px;
  display: flex;
  align-items: center;
}

.styles_history__oR8WX span {
  margin-top: 2px;
  margin-left: 10px;
  color: var(--darkGray);
  font-weight: 500;
}

.styles_eye__WtjWy {
  background-color: transparent;
  color: var(--orange);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
}

/* .eye svg {
  width: 22px;
  height: 22px;
}
 */

.styles_warning__aP8fw {
  color: red;
  margin-right: 8px;
  margin-bottom: -2px;
}

.styles_ordersButtons__l0dSn {
  display: flex;
  gap: 1rem;
}

.styles_containerIconViews__M1OoM {
  display: flex;
  justify-content: flex-end;
}

.styles_icons__4KVC\\+ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  width: 112px;
  height: 40px;
  border: 1px solid #aeaeae;
  border-radius: 6px;
  gap: 20px;
}

.styles_icons__4KVC\\+ > * {
  cursor: pointer;
}

.styles_containerStates__jZi2Y {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin: 20px 0px;
}

.styles_state__Xrl\\+r {
  width: 150px;
  height: 36px;
  border-radius: 30px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
}

.styles_stateInactive__ho20- {
  background-color: #e6e6e6;
  color: #878787;
}

.styles_stateActive__td8VB {
  background-color: var(--orange);
  color: #fff;
}

.styles_badge__dfEYV {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_badgeInactive__61dO4 {
  background-color: #ababab;
  color: #fff;
}

.styles_badgeActive__iHcV4 {
  background-color: #fff;
  color: #9e3223;
}

.styles_containerOrders__TOUZc {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.styles_order__koA5G {
  width: 347px;
  height: 100%;
  box-shadow: 0px 2px 15px 0px #64646426;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
}

.styles_header__zNDep {
  border-radius: 8px;
  padding: 2px;
  background: #f5f5f5;
}

.styles_header__zNDep p {
  margin: 0px;
}

.styles_ticketCreated__HEN4B {
  display: flex;
  justify-content: space-between;
}

.styles_ticket__soelf {
  font-weight: 400;
  font-size: 15px;
  color: #444444;
}

.styles_created__DaMgR {
  font-weight: 600;
  font-size: 18px;
  color: var(--orange);
}

.styles_typeOrder__srgZs {
  text-align: center;
  font-weight: 600;
  font-size: 18px;
}

.styles_orderDetail__Bf-aW {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.styles_orderItem__jx0SH p {
  margin: 2px;
}

.styles_orderItemTitle__Hf9kl {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  color: #383838;
}

.styles_orderItemValue__rvTjX {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #444444;
}

.styles_telephoneClock__u0YZl {
  display: flex;
  justify-content: space-between;
}

.styles_moreDetail__et2Uh {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.styles_labelItemBox__9F3wT {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.styles_label__\\+WJiE {
  font-size: 12px;
  font-weight: 400;
  color: #383838;
  margin: 0px;
}

.styles_itemBox__BdLSW {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 94px;
  height: 76px;
  border-radius: 8px;
  border: 1px solid #bfbfbf;
  background: #f5f5f5;
}

.styles_total__-ojtE {
  font-size: 20px;
  font-weight: 600;
  color: var(--orange);
}

.styles_tabName__N4IAM {
  position: relative;
}

.styles_tabBadge__08Z9T {
  position: absolute;
  right: -1.2rem;
  top: 50%;
  transform: translate(50%, -50%);
  background-color: var(--orange);
  color: #fff;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: BebasNeue;
}

@media screen AND (max-width: 720px) {
  .styles_ordersButtons__l0dSn {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/active-orders-monitor/styles/styles.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE;;AACF;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".averageTimeName {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  text-transform: uppercase;\n  margin-bottom: 7px;\n  margin-top: 28px;\n}\n\n.averageTimeContainer {\n  display: flex;\n  box-shadow: 0px 2px 15px 0px #64646426;\n  background-color: #fff;\n  border-radius: 6px;\n  height: 77px;\n  margin-bottom: 39px;\n}\n\n.averageTimeBox {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-right: 1px solid #cdcdcd;\n}\n\n.averageTimeBox:last-child {\n  border-right: none;\n}\n\n.averageTimeTitle {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 100%;\n  letter-spacing: 0px;\n}\n\n.averageTimeValue {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 100%;\n  text-transform: uppercase;\n  color: #4b4b4b;\n}\n\n.view {\n  position: relative;\n  padding-bottom: 80px;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.history {\n  background-color: #fff;\n  border-radius: 4px;\n  border: 0.5px solid var(--gray);\n  padding: 6px 15px;\n  display: flex;\n  align-items: center;\n}\n\n.history span {\n  margin-top: 2px;\n  margin-left: 10px;\n  color: var(--darkGray);\n  font-weight: 500;\n}\n\n.eye {\n  background-color: transparent;\n  color: var(--orange);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  cursor: pointer;\n}\n\n/* .eye svg {\n  width: 22px;\n  height: 22px;\n}\n */\n.warning {\n  color: red;\n  margin-right: 8px;\n  margin-bottom: -2px;\n}\n\n.ordersButtons {\n  display: flex;\n  gap: 1rem;\n}\n.containerIconViews {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.icons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n  width: 112px;\n  height: 40px;\n  border: 1px solid #aeaeae;\n  border-radius: 6px;\n  gap: 20px;\n}\n\n.icons > * {\n  cursor: pointer;\n}\n\n.containerStates {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin: 20px 0px;\n}\n\n.state {\n  width: 150px;\n  height: 36px;\n  border-radius: 30px;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  font-size: 10px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.stateInactive {\n  background-color: #e6e6e6;\n  color: #878787;\n}\n\n.stateActive {\n  background-color: var(--orange);\n  color: #fff;\n}\n\n.badge {\n  width: 25px;\n  height: 25px;\n  border-radius: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.badgeInactive {\n  background-color: #ababab;\n  color: #fff;\n}\n.badgeActive {\n  background-color: #fff;\n  color: #9e3223;\n}\n\n.containerOrders {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-top: 20px;\n}\n\n.order {\n  width: 347px;\n  height: 100%;\n  box-shadow: 0px 2px 15px 0px #64646426;\n  border-radius: 8px;\n  padding: 10px;\n  background-color: #fff;\n}\n\n.header {\n  border-radius: 8px;\n  padding: 2px;\n  background: #f5f5f5;\n}\n.header p {\n  margin: 0px;\n}\n\n.ticketCreated {\n  display: flex;\n  justify-content: space-between;\n}\n\n.ticket {\n  font-weight: 400;\n  font-size: 15px;\n  color: #444444;\n}\n\n.created {\n  font-weight: 600;\n  font-size: 18px;\n  color: var(--orange);\n}\n\n.typeOrder {\n  text-align: center;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.orderDetail {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.orderItem p {\n  margin: 2px;\n}\n.orderItemTitle {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.06px;\n  color: #383838;\n}\n\n.orderItemValue {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 18.75px;\n  color: #444444;\n}\n.telephoneClock {\n  display: flex;\n  justify-content: space-between;\n}\n\n.moreDetail {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.labelItemBox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 400;\n  color: #383838;\n  margin: 0px;\n}\n\n.itemBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 94px;\n  height: 76px;\n  border-radius: 8px;\n  border: 1px solid #bfbfbf;\n  background: #f5f5f5;\n}\n.total {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--orange);\n}\n\n.tabName {\n  position: relative;\n}\n\n.tabBadge {\n  position: absolute;\n  right: -1.2rem;\n  top: 50%;\n  transform: translate(50%, -50%);\n  background-color: var(--orange);\n  color: #fff;\n  border-radius: 50%;\n  width: 26px;\n  height: 26px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  font-family: BebasNeue;\n}\n\n@media screen AND (max-width: 720px) {\n  .ordersButtons {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"averageTimeName": `styles_averageTimeName__AXQKz`,
	"averageTimeContainer": `styles_averageTimeContainer__bEmoc`,
	"averageTimeBox": `styles_averageTimeBox__rnqol`,
	"averageTimeTitle": `styles_averageTimeTitle__ZOaCE`,
	"averageTimeValue": `styles_averageTimeValue__4Ohuf`,
	"view": `styles_view__+4Ep6`,
	"loader": `styles_loader__uCGJ0`,
	"history": `styles_history__oR8WX`,
	"eye": `styles_eye__WtjWy`,
	"warning": `styles_warning__aP8fw`,
	"ordersButtons": `styles_ordersButtons__l0dSn`,
	"containerIconViews": `styles_containerIconViews__M1OoM`,
	"icons": `styles_icons__4KVC+`,
	"containerStates": `styles_containerStates__jZi2Y`,
	"state": `styles_state__Xrl+r`,
	"stateInactive": `styles_stateInactive__ho20-`,
	"stateActive": `styles_stateActive__td8VB`,
	"badge": `styles_badge__dfEYV`,
	"badgeInactive": `styles_badgeInactive__61dO4`,
	"badgeActive": `styles_badgeActive__iHcV4`,
	"containerOrders": `styles_containerOrders__TOUZc`,
	"order": `styles_order__koA5G`,
	"header": `styles_header__zNDep`,
	"ticketCreated": `styles_ticketCreated__HEN4B`,
	"ticket": `styles_ticket__soelf`,
	"created": `styles_created__DaMgR`,
	"typeOrder": `styles_typeOrder__srgZs`,
	"orderDetail": `styles_orderDetail__Bf-aW`,
	"orderItem": `styles_orderItem__jx0SH`,
	"orderItemTitle": `styles_orderItemTitle__Hf9kl`,
	"orderItemValue": `styles_orderItemValue__rvTjX`,
	"telephoneClock": `styles_telephoneClock__u0YZl`,
	"moreDetail": `styles_moreDetail__et2Uh`,
	"labelItemBox": `styles_labelItemBox__9F3wT`,
	"label": `styles_label__+WJiE`,
	"itemBox": `styles_itemBox__BdLSW`,
	"total": `styles_total__-ojtE`,
	"tabName": `styles_tabName__N4IAM`,
	"tabBadge": `styles_tabBadge__08Z9T`
};
export default ___CSS_LOADER_EXPORT___;
